import React from 'react';
import Loader from '../../../../../../core/components/campaigns/campaigndetails/basketItemsV2/BasketItemsTabLoader';
import Controller from '../../../../../../core/components/campaigns/campaigndetails/basketItemsV2/BasketItemsTabController';
import View from './BasketItemsTab';

// Feature level subroutes
const BasketItemsTabV2 = (props) => {
  return (
    <Loader {...props}>
      <Controller>
        <View />
      </Controller>
    </Loader>
  );
};

export default BasketItemsTabV2;
